'use strict';

module.exports = /* @ngInject */ function ($scope, $http, apiConfig, feUniteCatalogService, feUniteSearchService, $mdToast, translationService, notificationService, uniteService) {
	var apiUrl = apiConfig.$get().apiUrl;
	var accessToken = apiConfig.$get().accessToken;
	var UNITE_MAX_OFFSET = 8000;

	$scope.loading = true;

	$scope.page = {
		offset: 0,
		pageSize: 20,
		totalPages: 0,
		totalEntries: 0,
		maxPages: 0
	};

	$scope.error = '';

	$scope.searchResult = null;
	$scope.catalogInfo = null;
	$scope.search = {
		searchString: '',
		customerCompanyId: '',
		supplierCompanyId: '',
		catalogId: '',
		catalogSearchString: ''
	};

	$scope.articleQuantity = {};

	$scope.init = function (search, customerCompanyId, supplierCompanyId, catalogId) {
		// speichern der search Daten für die pagination
		$scope.search.searchString = search;
		$scope.search.customerCompanyId = customerCompanyId;
		$scope.search.supplierCompanyId = supplierCompanyId;
		$scope.search.catalogId = catalogId;
		// load search result
		$scope.loadData();
	};

	$scope.basketLoading = {};

	/**
	 * load unite search result from api
	 * @param pageSize
	 */
	$scope.loadData = function (pageSize) {
		if (pageSize) {
			$scope.page.pageSize = pageSize;
		}
		if ($scope.page.pageSize > 0) {
			$scope.loading = true;
			var searchString = $scope.search.catalogId ? $scope.search.catalogSearchString : $scope.search.searchString;
			var offset = $scope.page.offset <= UNITE_MAX_OFFSET ? $scope.page.offset : UNITE_MAX_OFFSET;
			feUniteSearchService.search.get({
				search: searchString,
				customer: $scope.search.customerCompanyId,
				supplier: $scope.search.supplierCompanyId,
				offset: offset,
				limit: $scope.page.pageSize,
				catalogId: $scope.search.catalogId ? '&businessShopId=' + $scope.search.catalogId : ''
			}).$promise.then(function (result) {
				$scope.searchResult = result;
				$scope.searchResult.members.forEach(function (search) {
					$scope.articleQuantity[search.article.id] = search.article.minimumOrderQuantity;
				});
				$scope.page.totalEntries = result.total;
				$scope.page.totalPages = Math.ceil(result.total / $scope.page.pageSize);
				$scope.page.maxPages = Math.ceil(UNITE_MAX_OFFSET / $scope.page.pageSize);
				if ($scope.search.catalogId && $scope.catalogInfo === null) {
					uniteService.getCatalogInfo.get({
						customer: $scope.search.customerCompanyId,
						supplier: $scope.search.supplierCompanyId,
						businessShopId: $scope.search.catalogId
					}).$promise.then(function (catalog) {
						if (catalog) {
							$scope.catalogInfo = catalog;
							$scope.loading = false;
						} else {
							var msg = translationService.translate(_('Katalog nicht gefunden'));
							notificationService.showErrorNotification(msg, 5000);
							$scope.loading = false;
							$scope.error = msg;
						}
					}, function (error) {
						console.error('error', error);
						$scope.loading = false;
					});
				} else {
					$scope.loading = false;
				}
			}, function (error) {
				$scope.loading = false;
			});
		} else {
			$scope.searchResult = null;
			$scope.loading = false;
		}
	};

	/**
	 * Scrolls the view to the unite search result headline
	 */
	$scope.scrollToHeadline = function () {
		document.getElementById('uniteSearchHeadline').scrollIntoView();
	};

	/**
	 * show unite price
	 */
	$scope.showPrice = function (price, decimal) {
		// TODO: decimalChar entsprechend der Locale ziehen und Preise richtig anzeigen

		var decimalChar = ",";
		var decimal = price.toString().length - decimal;

		return price.toString().substr(0, decimal) + decimalChar + price.toString().substr(decimal);
	};

	/**
	 * Sets the page for the search result pagination and refetches the data with the page offset
	 * @param page
	 * @param exact (boolean): true if the exact setPageBy should be set
	 */
	$scope.setPage = function (page) {
		var offset = (page - 1) * $scope.page.pageSize < UNITE_MAX_OFFSET ? (page - 1) * $scope.page.pageSize : UNITE_MAX_OFFSET;
		page = page - 1;
		var oldOffset = $scope.page.offset;
		if (page < $scope.page.totalPages && page >= 0) {
			$scope.page.offset = offset;
		} else if (page >= $scope.page.totalPages) {
			$scope.page.offset = ($scope.page.totalPages - 1) * $scope.page.pageSize;
		} else {
			$scope.page.offset = 0;
		}
		if (oldOffset !== $scope.page.offset) {
			$scope.loadData();
			$scope.scrollToHeadline();
		}
	};

	/**
	 * adds one or more items to the basket
	 * @param article
	 * @param articleQuantity
	 * @param basketId
	 * @param customerCompanyId
	 * @param supplierCompanyId
	 */
	$scope.addToBasket = (article, articleQuantity, basketId, customerCompanyId, supplierCompanyId) => {
		$scope.basketLoading[article.id] = true;
		if (article.minimumOrderQuantity <= +articleQuantity) {
			$http(
				{
					method: 'GET',
					headers: {'Authorization': 'Bearer ' + accessToken},
					url: apiUrl + '/unite/article/' + encodeURI(article.id) +
						'/tobasket?quantity=' + articleQuantity +
						'&basket=' + basketId +
						'&customer=' + customerCompanyId +
						'&supplier=' + supplierCompanyId
				}
			).then(() => {
				// refresh basket view
				miniBasketRefresh();
				$scope.articleQuantity[article.id] = article.minimumOrderQuantity;
				$scope.basketLoading[article.id] = false;
				notificationService.showSuccessNotification(translationService.translate(
					_('Artikel erfolgreich in den Warenkorb gelegt')), 5000);
			}, (error) => {
				console.error(error);
				notificationService.showErrorNotification(translationService.translate(
					_('Artikel konnte nicht in den Warenkorb gelegt werden')), 5000);
			});
		} else { // case articleQuantity is smaller then the minimum order quantity
			var msg = translationService.translate(_('Die Mindestbestellmenge von ')) + article.minimumOrderQuantity + ' ' + translationService.translate(_('wurde noch nicht erreicht'));
			notificationService.showErrorNotification(msg, 5000);
		}
	};

	$scope.checkQuantity = uniteService.checkUniteArticleQuantity;

	/**
	 * opens the dojo popup from outside of the scope
	 */
	$scope.generateDetailUrl = function (searchElement, supplier, customer) {
		var customPopupStyles = 'width: 1000px; height: 600px;';
        const popupTitle = translationService.translate(_('Vorschau'))
		window.openPopup('catalog/article_show.htm&articleSource=unite&articleId=' + searchElement.article.id + '&supplier=' + supplier + '&customer=' + customer,
            popupTitle, null, null, customPopupStyles, true);
	}
};
